import React, {Component} from 'react'
import Login from '../../components/login';

class ModalTrigger extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  handleClose = () => {
    this.setState({
      open: false
    })
  }

  openModal = () => {
    this.setState({
      open: true
    })
  }

  render() {
    return (
      <div>
        <button style={ this.props.buttonStyle } onClick={this.openModal}>
          { this.props.children }
        </button>
        {this.state.open && <Login handleClose={this.handleClose} />}
      </div>
      
    );
  }
}

export default ModalTrigger;



// WEBPACK FOOTER //
// ./src/components/modaltrigger/index.js